import accountPageStyles from "./treatmentPage.module.css";
import Questionnaire from "../../components/questionnaire/questionnaire";
import { Category, ISubCategory, TLocationState } from "../../types/types";
import MyTreatment from "../../components/myTreatment/myTreatment";
import CalendarPage from "../calendar/calendar";
import MyPractice from "../../components/myPractice/myPractice";
import MyDocs from "../../components/myDocs/myDocs";
import { subCategories } from "../../utils/categories";
import MyPrescriptions from "../../components/myPrescriptions/myPrescriptions";
import MyQuestionnaires from "../../components/myQuestionnaires/myQuestionnaires";
import { useLocation, useNavigate } from "react-router-dom";
import { Dispatch, SetStateAction, useEffect } from "react";
import i18n from "../../i18n";
import BackArrowButton from "../../components/backArrowButton/backArrowButton";

function TreatmentPage({ activeCategory, setActiveCategory }: { activeCategory: ISubCategory, setActiveCategory: Dispatch<SetStateAction<Category>> })
 {
  const location = useLocation() as TLocationState;
  const navigate = useNavigate()
  const content = () => {
    if (activeCategory === subCategories.treatment) {
      return <MyTreatment />;
    } else if (activeCategory === subCategories.practice) {
      return <MyPractice />;
    } else if (activeCategory === subCategories.docs) {
      return <MyDocs />;
    } else if (activeCategory === subCategories.prescriptions) {
      return <MyPrescriptions />;
    } else if (activeCategory === subCategories.calendar) {
      return <CalendarPage setActiveCategory={setActiveCategory} />;
    } else if (activeCategory === subCategories.questionnaires) {
      return <MyQuestionnaires />;
    }
  };

  useEffect(() => {
    if (activeCategory !== subCategories.treatment && activeCategory !== subCategories.practice && activeCategory !== subCategories.docs && activeCategory !== subCategories.prescriptions && activeCategory !== subCategories.calendar && activeCategory !== subCategories.questionnaires) {
      setActiveCategory(Category.Treatment);
      navigate('/home');
    }
  }, [activeCategory, navigate, setActiveCategory])

  return (
    <main dir={i18n.dir()} className={accountPageStyles.main}>
      <BackArrowButton position={"center"} onClick={() => navigate(-1)} />
      <Questionnaire />
      {location?.state?.pathname === "videos" ?
        <MyPractice /> :
        content()}
    </main>
  );
}

export default TreatmentPage;
